/**
 * api管理
 */
import request from '../utils/request'
export default {
    // 批量获取单张表的数据
    singleformList(params) {
        return request({
            url: '/api/micro-backend/front/form/list',
            method: 'get',
            data: params
        })
    },
    // 获取资源库
    resourceLiball(params) {
        return request({
            url: '/api/micro-backend/front/antique3d/resource-lib-all',
            method: 'get',
            data: params
        })
    },
    // 高级检索（仅用于大屏端）
    advancedSearch(params) {
        return request({
            url: '/api/micro-backend/front/antique3d/advanced-search',
            method: 'get',
            data: params
        })
    },
    // 单表高级检索
    singleadvanceSearch(params) {
        // console.log(params)
        return request({
            url: '/api/micro-backend/front/form/advance-search',
            method: 'get',
            data: params
        })
    },
    // 单表高级检索,post格式，用于子菜单栏选项过多的情况
    singleadvanceSearchPost(data) {
        // console.log(data)
        return request({
            url: '/api/micro-backend/front/form/v2/advance-search',
            method: 'post',
            data
        })
    },
    // 单表行id（formUserId）去获取对应的数据 deptId对应fid  formId对应表单ID  formUserId对应行ID
    singleformUserId(deptId, formId, formUserId) {
        return request({
            url: '/api/micro-backend/front/form/list/' + deptId + '/' + formId + '/' + formUserId,
            method: 'get'
        })
    },
    // 表单字段结构  
    // deptId对应fid  formId对应表单ID
    formStruct(params) {
        return request({
            url: '/api/micro-backend/front/form/struct',
            method: 'get',
            data: params
        })
    },

    // 通过objectId获取文件地址
    getUrlByObjectId(objectId) {
        if (!objectId) return {}
        return request({
            url: `/api/micro-backend/front/form/objectid/${objectId}`,
            method: 'get',
        })
    },

    // 向表单添加数据
    addFormdata(formparams, data) {
        // console.log(data)
        return request({
            url: '/api/micro-backend/front/form/add/' + formparams.deptId + '/' + formparams.formId + '/' + formparams.uid,
            method: 'post',
            data: data,
            headers: { 'Content-Type': 'application/json;charset=UTF-8' }
        })
    },

    // 修改表单
    editForm(deptId, formUserId, params, formId) {
        return request({
            url: `/api/micro-backend/front/form/edit/${deptId}/${formUserId}?formId=${formId}`,
            method: 'put',
            headers: {
                'Content-Type': 'application/json;charset=UTF-8'
            },
            data: params
        })
    },

    // 删除表单数据
    deleteFormdata(formparams) {
        // console.log(formparams)
        return request({
            url: '/api/micro-backend/auth/del-form/' + formparams.formId + '/' + formparams.formUserId,
            method: 'post'
        })
    },

    // 通过formUserId获取表单信息
    getListByUserId(params) {
        return request({
            url: `/api/micro-backend/front/form/list/${params.deptId}/${params.formId}/${params.formUserId}`,
            method: 'get'
        })
    },

    getStaticData() {
        return request({
            url: `/api/micro-backend/download/attachment?alias=u3dFile,23`,
            method: 'get'
        })
    },

    uploadSingle(params) {
        return request({
            url: '/api/file/upload/single',
            method: 'post',
            data: params
        })
    },
    autoLogin() {
        return request({
            url: '/api/auth/jwt/auto-login',
            method: 'post'
        })
    },

    // 地图搜索
    map_search(params) {
        return request({
            url: '/api/micro-backend/front/form/map_search',
            method: 'get',
            data: params
        })
    },
    // 根据表单id获取数据
    getFormDetail(fid, formUserId, t) {
        return request({
            url: `/api/micro-backend/front/form/v2/list/${fid}/${formUserId}?t=${t}`,
            method: 'get',
        })
    },
    // 根据加密串获取列表数据
    getFormList(fid, t) {
        return request({
            url: `/api/micro-backend/front/form/v2/list?fid=${fid}&t=${t}&limit=100`,
            method: 'get',
        })
    },

    // 根据加密串获取分页数据
    getFormListByPage(fid, t, page, orderBy) {
        return request({
            url: `/api/micro-backend/front/form/v2/advance-search?deptId=${fid}&t=${t}&limit=50&page=${page}${orderBy ? `&orderBy=${orderBy}` : ''}`,
            method: 'get',
        })
    },

    // 表单接口标识生成加密串 未加权限
    redirectform(params) {
        return request({
            url: `/api/micro-backend/front/redirect/form?url=${params.url}&formAlias=${params.formAlias}`,
            method: 'GET',
        })
    },

    // 单表高级检索v2
    singleadvanceSearchv2(params) {
        return request({
            url: '/api/micro-backend/front/form/v2/advance-search',
            method: 'get',
            data: params
        })
    },

    /**
     *  获取验证码
     * @param {Number} params 手机号
     * @returns
     */
    getVerificationCode (param) {
        return request({
            url: `/api/message/send/verification-code?phoneNumber=${param}&type=1`,
            method: 'get'
        })
    },

    /**
     *  ⼿机号短信登录(⾃动注册)
     * @param {*} params
     * @returns
     */
    membertoken (params) {
        return request({
            url: '/api/auth/jwt/member-token',
            method: 'post',
            data: params
        })
    },
}


